<template>
  <div class="certificates">
    <v-text-field
      label="Поиск по коду сертификата"
      v-model="search"
      filled
      class="search"
    >
      <v-btn slot="append" color="primary" @click="getById">
        <v-icon left>mdi-magnify</v-icon> искать
      </v-btn>
      <v-btn slot="append" @click="getAll" v-if="search.length > 0">
        <v-icon left>mdi-close</v-icon> очистить
      </v-btn>
    </v-text-field>

    <v-card class="search notif" v-if="searchCode == 'error'">
      <p>Сертификат с таким кодом не найдено</p>
    </v-card>

    <v-data-table :items="certificates" class="elevation-1 table_releases">
      <template slot="header" :header="headers">
        <thead>
          <tr>
            <th v-for="header in headers" :key="header.text">
              <div class="text">
                {{ header.text }}
              </div>
            </th>
          </tr>
        </thead>
      </template>
      <template v-slot:item="{ item }">
        <tr>
          <td class="text-start">{{ getTime(item.date) }}</td>
          <td class="text-start">{{ item.name }}</td>
          <td class="text-start">{{ item.email }}</td>
          <td class="text-start">
            {{
              item.amountOrService == "forService" ? "На услугу" : "На сумму"
            }}
            <b>{{ item.price }}руб.</b>
          </td>
          <td class="text-start">
            {{ item.where == "toEmail" ? "На email" : item.address }}
          </td>
          <!-- <td class="text-start">
            {{ item.where == "toEmail" ? "На эл. почту" : "Доставка" }}
          </td> -->
          <td class="text-start">{{ item.code }}</td>
          <!-- <td class="text-start">{{ checkTermCode(item.date) }}</td> -->
          <td class="text-start">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  :color="item.paid ? 'success' : 'error'"
                  >{{
                    item.paid ? "mdi-checkbox-marked-circle" : "mdi-cancel"
                  }}</v-icon
                >
              </template>
              <span>{{ item.paid ? "Оплачено" : "НЕ оплачено" }}</span>
            </v-tooltip>
            <v-btn
              depressed
              small
              color="black"
              class="white--text ml-5"
              @click="openMoreInfo(item)"
              >Посмотреть</v-btn
            >
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import axios from "axios";

import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
dayjs.extend(relativeTime);

export default {
  name: "Certificates",
  data: () => ({
    certificates: [],
    headers: [
      {
        text: "Дата оформление",
        sortable: false,
      },
      {
        text: "Имя",
        sortable: false,
      },
      {
        text: "Email",
        sortable: false,
      },
      {
        text: "Тип сертификата",
        sortable: false,
      },
      {
        text: "Куда",
        sortable: false,
      },
      // {
      //   text: "Тип сертификата",
      //   sortable: false,
      // },
      {
        text: "Код сертификата",
        sortable: false,
      },
      // {
      //   text: "Годность сертификата",
      //   sortable: false,
      // },
      {
        text: "Действие",
        sortable: false,
      },
    ],
    search: "",
    searchCode: "",

    rowsPerPageItems: [10, 20, 30, 40],
    pagination: {
      rowsPerPage: 20,
    },
  }),
  created() {
    this.getAll();
  },
  methods: {
    getTime(time) {
      return dayjs(parseInt(time)).format("YYYY-MM-DD/HH:mm");
    },
    checkTermCode(time) {
      let first_date = new Date(time);
      let second_date = new Date(Date.now());
      first_date.setDate(first_date.getDate() + 30);

      if (first_date.getTime() > second_date.getTime()) {
        return "Годен";
      } else {
        return "Истек срок";
      }
    },
    getAll() {
      axios
        .get(`${process.env.VUE_APP_AXIOS}/gift/`, {
          headers: {
            token: localStorage.getItem("token"),
          },
        })
        .then((res) => {
          this.certificates = res.data.certificates;
          this.search = "";
          this.searchCode = "";
          console.log(res.data);
        });
    },
    getById() {
      axios
        .get(`${process.env.VUE_APP_AXIOS}/gift/${this.search}`, {
          headers: {
            token: localStorage.getItem("token"),
          },
        })
        .then((res) => {
          this.certificates = [];
          this.certificates.push(res.data.certificates);
          this.searchCode = "";
        })
        .catch((err) => {
          if (err) {
            this.searchCode = "error";
          }
        });
    },
    openMoreInfo(order) {
      this.$store.state.more.data = order;
      this.$store.state.more.active = true;
    },
  },

  mounted() {},
};
</script>

<style lang="scss" scoped>
</style>